/* eslint-disable max-len */
export default {
  'Web.time': "o'clock",
  'Web.U2UpLimit': 'Rise in voltage protection U>>',
  'Web.UUpAve': 'Rise in voltage protection U>',
  'Web.U1LoLimit': 'Voltage decreasing protection U<',
  'Web.U2LoLimit': 'Voltage decreasing protection U<<',
  'Web.F1LoLimit': 'Frequency decreasing protection f<',
  'Web.F1UpLimit': 'Frequency increasing protection f>',
  'Web.PUtype': 'Active power reduction (voltage depending) P(U) ',
  'Web.ProductionData': 'Serial number power electronics',

  'Web.Buttons.Save': 'Save',
  'Web.ChangePassword.Buttons.ChangePassword': 'Set new password',
  'Web.ChangePassword.CurrentPassword': 'Old password',
  'Web.ChangePassword.Input.OldPassword': 'Please enter your previous password.',
  'Web.ChangePassword.Messages.Failure': 'Your password could not be changed.',
  'Web.ChangePassword.Messages.Success': 'Your password was changed successfully.',
  'Web.ChangePassword.NewPassword': 'Password',
  'Web.ChangePassword.RepeatPassword': 'Repeat password',
  'Web.ChangePassword.Text':
    'Please enter your old password to change it and replace it with a new one.',
  'Web.ChangePassword.Title': 'Change password',
  'Web.device_selection_title': 'System list',
  'Web.Device.List.Placeholder': 'Enter your search term...',
  'Web.EditProfile.ChangePassword': 'Change Password',
  'Web.EditProfile.FirstName': 'Name',
  'Web.EditProfile.LastName': 'Surname',
  'Web.EditProfile.Location': 'System Location',
  'Web.EditProfile.Street': 'Street and house no.',
  'Web.EditProfile.Zip': 'Zip code and city',
  'Web.EditProfile.PostalCode': 'Zip code',
  'Web.EditProfile.Town': 'Town',
  'Web.EditProfile.Country': 'Country',
  'Web.EditProfile.PhoneNumber': 'Phone number',
  'Web.Errors.Fatal.Device.Message':
    'Unfortunately no Smart Battery could be found for you. We are happy to help you to clarify this.',
  'Web.Errors.Fatal.Device.Title': 'No system found!',
  'Web.Errors.Input.Attempts': 'Too many attempts. Please try again later.',
  'Web.Errors.Login': 'Your data does not match. <br>Please try again.',
  'Web.expert_view_battery_inverter_charging_current': 'Charging current',
  'Web.expert_view_battery_inverter_charging_power': 'Charging power',
  'Web.expert_view_battery_inverter_cos_current': 'Cos(φ) current',
  'Web.expert_view_battery_inverter_discharging': 'Discharge power',
  'Web.expert_view_battery_inverter_discharging_current': 'Discharging current',
  'Web.expert_view_battery_inverter_lower_limit': 'Lower limit',
  'Web.expert_view_battery_inverter_lower_limit_max': 'Lower limit max.',
  'Web.expert_view_battery_inverter_lower_limit_min': 'Lower limit min.',
  'Web.expert_view_battery_inverter_performance_set_point': 'Performance setpoint',
  'Web.expert_view_battery_inverter_powerfactor': 'Power factor',
  'Web.expert_view_battery_inverter_q_cr_time': 'Reactive power time constant',
  'Web.expert_view_battery_inverter_q_fix_var': 'Reactive power',
  'Web.expert_view_battery_inverter_qmax_smax': 'Ratio Qmax / Smax',
  'Web.expert_view_battery_inverter_upper_limit': 'Upper limit',
  'Web.expert_view_battery_inverter_upper_limit_max': 'Upper limit max.',
  'Web.expert_view_battery_inverter_upper_limit_min': 'Upper limit min.',
  'Web.expert_view_battery_inverter_performance_discharge_set_point': 'Setpoint Discharging Power',
  'Web.expert_view_battery_inverter_performance_charge_set_point': 'Setpoint Charging Power',
  'Web.expert_view_battery_inverter_voltage_max': 'Max. Voltage',
  'Web.expert_view_battery_inverter_voltage_min': 'Min. Voltage',
  'Web.expert_view_battery_inverter_charging_current_max': 'Max. Charging Current',
  'Web.expert_view_battery_inverter_discharging_current_max': 'Max. Discharging Current',
  'Web.expert_view_battery_inverter_voltage': 'Voltage',
  'Web.expert_view_country_code_austria': '0043 Austria',
  'Web.expert_view_country_code_germany': '0049 Germany',
  'Web.expert_view_country_code_switzerland': '0041 Switzerland',
  'Web.expert_view_d4': 'D4',
  'Web.expert_view_d5': 'D5',
  'Web.expert_view_d6': 'D6',
  'Web.expert_view_d7': 'D7',
  'Web.expert_view_error_battery': 'Error Battery',
  'Web.expert_view_error_inverter': 'Error Inverter',
  'Web.expert_view_error_system': 'Error System',
  'Web.expert_view_error_title': 'Error codes',
  'Web.expert_view_heat_pump_switch': 'Heat pump connected via SG Ready',
  'Web.expert_view_heat_pump_title': 'Heat pump',
  'Web.expert_view_inverter_title': 'Photovoltaic system',
  'Web.expert_view_land_codes_title': 'Country code',
  'Web.expert_view_limit_setup_option_0': 'Off',
  'Web.expert_view_limit_setup_option_1': 'On',
  'Web.expert_view_limit_setup_title': 'Limit setup',
  'Web.expert_view_num_of_battery_module_title': 'Number of battery modules',
  'Web.expert_view_operation_mode_options_option_0': 'Self-consumption optimization',
  'Web.expert_view_operation_mode_options_option_1': 'Set point mode',
  'Web.expert_view_operation_mode_options_option_2': 'SoC mode',
  'Web.expert_view_operation_mode_title': 'Operation mode',
  'Web.expert_view_pv_inverter_power_title': 'Setting photovoltaic inverter power',
  'Web.expert_view_pv_power_title': 'Total power of photovoltaic modules',
  'Web.expert_view_q_u_label_reactive_rel': 'Reactive power Q / Sr',
  'Web.expert_view_q_u_label_voltage_rel': 'Voltage U / Un',
  'Web.expert_view_reaction_time_title': 'Reaction time',
  'Web.expert_view_settings_cos_phi_for_all': 'All',
  'Web.expert_view_settings_cos_phi_options_at_option_0': 'One support point',
  'Web.expert_view_settings_cos_phi_options_at_option_1': 'Support points cos(φ) (power-dependent)',
  'Web.expert_view_settings_cos_phi_options_at_option_2': 'Support points Q(U) (voltage-dependent)',
  'Web.expert_view_settings_cos_phi_options_de_option_0': 'One support point',
  'Web.expert_view_settings_cos_phi_options_de_option_1': 'Support points cos(φ) (power-dependent)',
  'Web.expert_view_settings_cos_phi_title': 'Setting value: cos-phi',
  'Web.expert_view_total_power_battery': 'Smart Battery: Discharge per day Σ',
  'Web.expert_view_total_power_grid_feed': 'Grid: Export Σ',
  'Web.expert_view_total_power_grid_reference': 'Grid: Import Σ',
  'Web.expert_view_total_power_solar_feed': 'Photovoltaic: Infeed Σ',
  'Web.expert_view_total_power_title': 'Total power',
  'Web.expert_view_version_api': 'API Version:',
  'Web.expert_view_version_firmware': 'Firmware version:',
  'Web.expert_view_version_model': 'Model version:',
  'Web.expert_view_version_inverter_bdc': 'BDC',
  'Web.expert_view_version_inverter_ens': 'ENS',
  'Web.expert_view_version_inverter_hmi_app': 'HMI_APP',
  'Web.expert_view_version_inverter_hmi_fbl': 'HMI_FBL',
  'Web.expert_view_version_inverter_pu': 'PU',
  'Web.expert_view_save_settings_failure': 'Saving failed',
  'Web.expert_view_save_settings_success': 'Saved successfully',
  'Web.expert_view_save_settings': 'Save input values',
  'Web.expert_view_pv_inverter_ip_address': 'Inverter IP',
  'Web.expert_view_inverter_type_options': 'Control of PV inverter',
  'Web.expert_view_inverter_type_option_1': 'Standard (4 digital inputs)',
  'Web.expert_view_inverter_type_option_2': 'SMA Sunny Boy (Modbus TCP)',
  'Web.ExpertMode.Buttons.Retry': 'Try again',
  'Web.ExpertMode.Headline': 'SIEMENS Junelight',
  'Web.ExpertMode.Items.Battery.Battery': 'Battery charge (SOC)',
  'Web.ExpertMode.Items.Battery.Cycles': 'Number of cycles',
  'Web.ExpertMode.Items.Battery.MaxCharge': 'Charging current: Max.',
  'Web.ExpertMode.Items.Battery.Voltage': 'Battery voltage',
  'Web.ExpertMode.Items.Power.Consumer': 'Consumer',
  'Web.ExpertMode.Items.Power.Grid': 'Network',
  'Web.ExpertMode.Items.Power.Inverter': 'Smart Battery Inverter',
  'Web.ExpertMode.Items.Power.PV': 'Photovoltaic',
  'Web.ExpertMode.Items.Versions.ModelDate': 'Model Date:',
  'Web.ExpertMode.Items.Versions.ModelName': 'Model Name:',
  'Web.ExpertMode.Items.Versions.Versions': 'Versions',
  'Web.ExpertMode.Messages.NoData': 'Not all data of the Smart Battery is currently available.',
  'Web.ExpertMode.Sections.Battery': 'Smart Battery',
  'Web.ExpertMode.Sections.Power': 'Effective power',
  'Web.ExpertMode.Serial': 'Serial number:',
  'Web.ExpertMode.Items.Inverter.title': 'Smart Battery inverter versions',
  'Web.forgot_password_error_user_not_found': 'The specified e-mail is not registered.',
  'Web.ForgotPassword.Buttons.Submit': 'Send confirmation code',
  'Web.ForgotPassword.ContactDescription':
    'If you have also forgotten your e-mail address, please contact the Siemens service.',
  'Web.ForgotPassword.Description':
    'Please enter your e-mail address so that we can send you the confirmation code to reset your password.',
  'Web.ForgotPassword.Title': 'Reset password',
  'Web.ForgotPassword.Password.Placeholder': 'Password',
  'Web.ForgotPassword.RepeatPassword.Placeholder': 'Repeat password',
  'Web.chart_battery_money_earned': 'saved',
  'Web.chart_battery_co2_saved': 'saved',
  'Web.history_charts_today_with_date': 'Today',
  'Web.History.AggregationPeriod.Day': 'Day',
  'Web.History.AggregationPeriod.Month': 'Month',
  'Web.History.AggregationPeriod.Week': 'Week',
  'Web.History.AggregationPeriod.Year': 'Year',
  'Web.History.Authonomy.Legend.Authonomy': 'total autarky',
  'Web.History.Authonomy.Legend.Battery': 'Share of battery',
  'Web.History.Authonomy.Legend.Solar': 'Share of PV system',
  'Web.History.Authonomy.Title': 'Average <br>autarky',
  'Web.History.Battery.Title': 'Average <br>battery charge',
  'Web.History.Consumption.Legend.Battery': 'From the battery',
  'Web.History.Consumption.Legend.Grid': 'From the grid',
  'Web.History.Consumption.Legend.PV': 'From the PV system',
  'Web.History.Consumption.Title': 'Total consumption',
  'Web.History.SolarGeneration.Title': 'Solar generation',
  'Web.History.chart_tooltip_solar_battery': 'Into the battery',
  'Web.History.chart_tooltip_solar_direct_consumption': 'Direct consumption',
  'Web.History.chart_tooltip_solar_grid': 'Into the grid',
  'Web.History.Messages.NoData': 'There is no data for the selected period.',
  'Web.History.Title': 'History',
  'Web.history_chart_clicked_send_email': 'Sending e-mail...',
  'Web.history_email_failed': 'Unable to send an e-mail with the requested data to your account.',
  'Web.history_email_sent_success': 'The selected data has been sent to you by e-mail.',
  'Web.Hotline.Text': 'Monday to Friday from 8am to 5pm',
  'Web.Hotline.Title': 'Siemens Hotline',
  Web: {
    imprint: {
      address: {
        city: '80333 Munich Germany',
        name: 'Siemens Aktiengesellschaft',
        street: 'Werner-von-Siemens-Straße 1',
        title: 'Corporate headquarters'
      },
      board: 'Board',
      chairman: 'Chairman of the Supervisory Board',
      company: {
        address: 'Berlin and Munich, Germany',
        title: 'Headquarter of the company'
      },
      currentUpdate: {
        date: 'State from 21.09.2017',
        leadTo: 'here',
        text: 'The current version can be found'
      },
      identificationNr: 'VAT identification number',
      register: {
        address: 'Berlin-Charlottenburg, HRB 12300 Munich, HRB 6684',
        title: 'Register'
      },
      responsible: {
        city: '80333 Munich Germany',
        name: 'Siemens Aktiengesellschaft Communications',
        street: 'Werner-von-Siemens-Straße 1',
        title: 'Responsible according to § 55 Abs. 2 RStV'
      },
      title: 'Imprint'
    }
  },
  'Web.Items.Battery.Title': 'Battery',
  'Web.LegalDocuments.Buttons.Accept': 'Accept',
  'Web.LegalDocuments.Buttons.Decline': 'Decline',
  'Web.Login.Header': 'Welcome to <br> Siemens Junelight',
  'Web.Login.Email': 'E-mail',
  'Web.Overview.Authonomy': 'Autarky',
  'Web.Overview.Battery': 'Battery',
  'Web.Overview.DisplayableItem.Buy': 'Importing',
  'Web.Overview.DisplayableItem.Charge': 'Charging',
  'Web.Overview.DisplayableItem.Consume': 'Consuming',
  'Web.Overview.DisplayableItem.Discharge': 'Discharging',
  'Web.Overview.DisplayableItem.KilowattPerHour': 'kWh',
  'Web.Overview.DisplayableItem.Sell': 'Feeding',
  'Web.Overview.DisplayableItem.Sold': 'Sold',
  'Web.Overview.Expenses': 'Bought',
  'Web.Overview.Produce': 'Producing',
  'Web.Overview.Title': 'Overview',
  'Web.Overview.Today': 'Today',
  'Web.percentage': '%',
  'Web.percentage_with_value': '%1$s%%',
  'Web.placeholder_with_empty_string': '',
  'Web.placeholder_empty_string': '',
  'Web.system_electricity_price': 'Electricity Price',
  'Web.system_electricity_price_error': 'Value must be between {0} and {1}',
  'Web.system_electricity_price_per_kw': 'Price per kWh',
  'Web.system_electricity_price_saved': 'Electricity price is now set to {0} per kWh',
  'Web.system_electricity_price_per_kw_button': 'Save',
  'Web.profile_error_change_profile_failed':
    'Sorry, your profile could not be saved due to server issues.',
  'Web.Profile.Buttons.Conditions': 'Terms of Use',
  'Web.Profile.Buttons.Edit': 'Edit profile',
  'Web.Profile.Buttons.Imprint': 'Imprint',
  'Web.Profile.Buttons.Logout': 'Logout',
  'Web.Profile.Buttons.OpenSource': 'Open source software',
  'Web.Profile.Buttons.Privacy': 'Privacy Policy',
  'Web.Profile.Contakt': 'Contact',
  'Web.Profile.Copyright': '© Siemens AG, 2018',
  'Web.Profile.Email': 'E-mail address',
  'Web.Profile.Service': 'Service',
  'Web.Profile.Title': 'Profile',
  'Web.register_error_invalid_email': 'Please enter a valid e-mail address.',
  'Web.register_error_invalid_password':
    'Your password does not contain all necessary characters. Please try again.',
  'Web.register_error_passwords_do_not_match':
    'Your password information does not match. Please try again.',
  'Web.Registration.Buttons.Register': 'Register',
  'Web.Registration.DataUsage': 'Siemens may use my personal data for advertising purposes.',
  'Web.Registration.Email': 'E-mail address',
  'Web.Registration.FirstName': 'Name',
  'Web.Registration.Input.FirstName': 'Please enter a valid first name.',
  'Web.Registration.Input.LastName': 'Please enter a valid last name.',
  'Web.Registration.LastName': 'Surname',
  'Web.Registration.Legal.Text': 'By registering, you accept the {0} and {1} of Siemens.',
  'Web.Registration.Password': 'Password',
  'Web.Registration.RepeatPassword': 'Repeat password',
  'Web.Registration.Title': 'Register',
  'Web.ResetPassword.Code': 'Verification code',
  'Web.ResetPassword.Description':
    'Please enter the verification code sent to you by e-mail and your new password.',
  'Web.service_handover_success_header': 'Note',
  'Web.ServiceMode.Buttons.Request': 'Apply for activation',
  'Web.ServiceMode.Buttons.withdraw': 'Withdraw',
  'Web.ServiceMode.Description':
    'You can grant another person access to your Smart Battery. This is e.g. necessary so that your technician can carry out service work on your Smart Battery. Enter the e-mail address of the person concerned. The activation is valid from the time of application until it gets revoked.',
  'Web.ServiceMode.Errors.400':
    "An unexpected problem occurred. Check the correct technician's e-mail address or try again later.",
  'Web.ServiceMode.Errors.401':
    'The activation could not be carried out successfully because you do not have the required authorization. Only owners of a Smart Battery are authorized.',
  'Web.ServiceMode.Errors.403':
    'The activation could not be completed successfully because their user account could not be verified. Please log in again in the application.',
  'Web.ServiceMode.Errors.404':
    'The activation could not be carried out successfully. Check the correct spelling of the e-mail address and try again. If this is unsuccessful, contact SIEMENS Service.',
  'Web.ServiceMode.Errors.500':
    'Due to server issues, this process is currently not possible. Please try again later.',
  'Web.ServiceMode.Messages.Success':
    'Activation successfully requested. The released person can now access your Smart Battery.',
  'Web.ServiceMode.Title': 'Service mode',
  'Web.service_mode_list':
    'The following users have access to your Smart Battery. You can undo the access at any time.',
  'Web.service_mode_list_error': 'An unexpected problem occurred. Please try again later.',
  'Web.service_mode_revoke_fail':
    'The access to the Smart Battery for {0} could not be withdrawn. Please try again later.',
  'Web.service_mode_revoke_success': '{0} has now no longer have access to your Smart Battery.',
  'Web.system_button_system_list': 'System list',
  'Web.System.Battery': 'Battery status',
  'Web.System.BatteryState.Error': 'Disorder',
  'Web.System.BatteryState.Ok': 'Ready',
  'Web.System.BatteryState.Problem': 'Offline',
  'Web.System.Buttons.ExpertMode': 'Expert view',
  'Web.System.Cycles': 'Charging cycles',
  'Web.System.Headline': 'Junelight Smart Battery',
  'Web.System.Title': 'System',
  'Web.System.TotalCapacity': 'Capacity',
  'Web.unit_kilo_watt_pico': 'kWp',
  'Web.unit_kw': 'kW',
  'Web.unit_solo_kw': 'kW',
  'Web.unit_seconds': 's',
  'Web.unit_seconds_with_value': 's',
  'Web.unit_variable': 'var',
  'Web.unit_W': 'W',
  'Web.unit_with_space_amper': ' A',
  'Web.unit_with_space_kilo_watt_hour': ' kWh',
  'Web.unit_with_space_voltage': ' V',
  'Web.unit_with_space_watt': ' W',
  'Web.Validation.Password.Lenght': 'min. 8, max 32 characters',
  'Web.Validation.Password.Number': 'min. one number',
  'Web.Validation.Password.SpecialLetter':
    'min. a special character from ^ $ *. [] { } ( ) ? - " ! @ # % & / \\\\ , > < \' : ; | _ ~ `',
  'Web.Validation.Password.UppercaseLetter': 'min. one capital letter',
  'Web.Validation.RepeatPassword.Mismatch': 'Your password information does not match',
  'Web.Verification.Buttons.Confirm': 'Confirm',
  'Web.Verification.Buttons.Resend': 'Resend verification code',
  'Web.Verification.Description':
    'You will find the verification code in the e-mail you received. This process may take a few moments, please be patient.',
  'Web.Verification.Messages.Failure':
    'This verification code does not match the associated email address. Please try again. If this error persists, contact support for help.',

  'Web.expert_view_country_code_austria_d4': '0043 Austria TOR D4',
  'Web.expert_view_country_code_austria_producer': '0043 Austria TOR Producer',
  'Web.expert_view_heat_pump_slider': 'Surplus',
  'Web.expert_view_smart_home_options': 'Smart home',
  'Web.expert_view_smart_home_provider': 'Provider',
  'Web.expert_view_smart_home_none': 'None',
  'Web.expert_view_smart_home_loxone': 'Loxone',
  'Web.expert_view_smart_home_knx': 'KNX',
  'Web.expert_view_smart_home_knx_ip_port': 'KNX IP address and port',
  'Web.expert_view_smart_home_knx_device_id': 'KNX Device ID',
  'Web.expert_view_smart_home_junelight_ip': 'Junelight IP address',
  'Web.expert_view.smart_home_knx_ip_port_hint': '0.0.0.0:0000',
  'Web.expert_view_limit_setup_switch': 'Power limitation',
  'Web.expert_view_f_derate': 'LFSM-O',
  'Web.expert_view_f_grad_reduc': 'Static',

  'Web.expert_view_p_u_crtime_title': 'P(U) control time constant',
  'Web.expert_view_wait_time_after_fail_title': 'Waiting time after grod fault',
  'Web.expert_view_voltage_dropout_title': 'Voltage protection decoupling point U',
  'Web.expert_view_grid_protection_title': 'Grid coupling protection',
  'Web.expert_view_power_reduction_title': 'Active power reduction at overfrequency',

  'Web.expert_view_voltage_protection_low_ueff': 'Undervoltage protection Ueff',
  'Web.expert_view_trip_time_ueff': 'Trip time for Ueff',
  'Web.expert_view_voltage_protection_ueff': 'Voltage protection Ueff',
  'Web.expert_view_monitoring_ueff': 'Monitoring protection Ueff',

  'Web.expert_view_frequence_protection': 'Frequency protection f',
  'Web.expert_view_frequency_decrease_protection': 'Frequency drop protection f &lt;',
  'Web.expert_view_frequency_increase_protection': 'Frequency increase protection f&gt;',
  'Web.expert_view_tor_toggle_title': 'Inverter protection functions',

  'Web.expert_view_news_title': "What's New",
  'Web.Profile.Buttons.News': "What's New",

  'Web.Overview.DisplayableItem.StandBy': 'Stand By',

  /** Authenticator */

  // Confirm Signup
  'Web.Authenticator.confirmSignUp.NotAuthorizedException':
    'The verification code has expired. Please have it sent to you again.',
  'Web.Authenticator.confirmSignUp.CodeMismatchException':
    'This verification code does not match the associated e-mail address. Please try again. If this error persists, contact the service for help.',

  //Forgot password
  'Web.Authenticator.passwordForgotten.default': 'An error has occurred. Please try again.',
  'Web.Authenticator.passwordForgotten.UserNotFoundException':
    'The specified e-email is not registered.',
  'Web.Authenticator.passwordForgotten.CodeMismatchException':
    'The verification code is incorrect. Please try again.',
  'Web.Authenticator.passwordForgotten.ExpiredCodeException':
    'The verification code has expired. Please have it sent to you again.',

  /** /Authenticator */
  'Web.expert_view_cr_time_read': 'P(U)-control time',
  'Web.expert_view_recon_time_read': 'Waiting time after grid failure',
  'Web.expert_view_voltage_dropout_hi': 'Voltage protection decoupling point U>',
  'Web.expert_view_voltage_dropout_lo': 'Voltage protection decoupling point U<',
  'Web.expert_view_u1_limit_hi': 'Voltage protection Ueff>>',
  'Web.expert_view_u2_limit_lo': 'Voltage protection Ueff<<',
  'Web.expert_view_u1_time_hi': 'Trip time Ueff>>',
  'Web.expert_view_u2_time_lo': 'Trip time Ueff<<',
  'Web.expert_view_f1_limit_hi': 'Frequency protection f>',
  'Web.expert_view_f1_limit_lo': 'Frequency protection f<',
  'Web.expert_view_u1_limit_lo': 'Undervoltage protection Ueff<',
  'Web.expert_view_u1_time_lo': 'Trip time for Ueff<',
  'Web.expert_view_u_ave_hi': 'Monitoring protection Ueff>',
  'Web.expert_view_deraring_lsfm_o': 'LFSM-O',
  'Web.expert_view_derating_static': 'Static',

  'Web.expert_view_tor_read_title': 'TOR',
  'Web.expert_view_pv_inverter_ip_type': 'Missing String',

  'Web.unit.hertz': 'Hz',

  'Web.expert_view_heating_element_title': 'Heater',
  'Web.expert_view_heating_element_slider': 'Surplus power',
  'Web.expert_view_heating_element_switch': 'Heater connected via D2',

  'Web.chartAutarky.title': '',
  'Web.chartAutarky.desc': '',
  'Web.disclaimer.text':
    'This website will no longer be supported after May 30th, 2021. Please download the Junelight app free of charge for your iOS or Android mobile device.'
};
